<template>
  <IQOS :title="review.author || $t('reviews.anonymous')" required>
    <template #actions>
      <span class="qrw-heading-xs v1-grey-6-color">{{
        review.created_at | formatDate
      }}</span>
    </template>
    <div class="qrw-paragraph-md mt-16" v-if="review.comment">
      {{ review.comment }}
    </div>

    <div class="review-footer mt-16">
      <IQOSModeBadge :mode="review.mode" v-if="review.mode !== 'choose_mode'"/>
      <div class="qrw-heading-xs bold green-6-color">
        <span class="mr-8">{{ review.score }}</span>
        <BaseIcon icon="thumb-up"/>
      </div>
    </div>
  </IQOS>
</template>

<script>
export default {
  props: {
    review: Object,
    unread: Boolean,
  },
  computed: {
    modeTitle() {
      return {
        'inside': 'INSIDE',
        'preorder': 'TAKEAWAY',
        'hotels': 'ROOMS',
        'choose_mode': 'CAFE PAGE',
        'reserve': 'RESERVE',
        'delivery': 'DELIVERY',
        'cafe_review': 'CAFE'
      }[this.review.mode];
    }
  }
};
</script>

<style scoped>
.review-footer {
  display: flex;
  justify-content: space-between;

  align-content: center;
  align-items: center;
}
</style>
